module.exports = __webpack_public_path__ + "img/pluto64.8753188c.jpg";